import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    DateField,
    DateInput,
    RichTextInput,
    SelectField
} from 'react-admin';
import RichTextInputInput from 'ra-input-rich-text';

export const ArticleList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="Title" label="标题" />
            <TextField source="Author" label="作者" />
            <TextField source="Category" label="分类" />
            <SelectField source="Status" label="状态" choices={[
                { id: 0, name: '草稿' },
                { id: 1, name: '待审核' },
                { id: 2, name: '已发布' },
                { id: 3, name: '驳回' },
            ]} />
            <DateField source="CreateTime" label="创建时间" />
            <EditButton />
        </Datagrid>
    </List>
);

export const ArticleEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Title" label="标题" />
            <RichTextInputInput source="Content" label="内容" />
            <TextInput source="Author" label="作者" />
            <TextInput source="Category" label="分类" />
            <SelectInput source="Status" label="状态" choices={[
                { id: 0, name: '草稿' },
                { id: 1, name: '待审核' },
                { id: 2, name: '已发布' },
                { id: 3, name: '驳回' },
            ]} />
            <DateInput source="PublishTime" label="发布时间" />
        </SimpleForm>
    </Edit>
);

export const ArticleCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="Title" label="标题" />
            <RichTextInputInput source="Content" label="内容" />
            <TextInput source="Author" label="作者" />
            <TextInput source="Category" label="分类" />
            <SelectInput source="Status" label="状态" initialValue={0} choices={[
                { id: 0, name: '草稿' },
                { id: 1, name: '待审核' },
                { id: 2, name: '已发布' },
                { id: 3, name: '驳回' },
            ]} />
        </SimpleForm>
    </Create>
);
